import { getCurrentRawZoom } from '../../../redux-jigsaw/zoom/selectors';

export function isFullScreen(state) {
  return state.ui.common.reader.isFullScreen;
}

export function getZoomScalingFactor(state) {
  return state.ui.common.reader.zoomScalingFactor;
}

export function getCurrentScaledZoom(state) {
  const rawZoom = getCurrentRawZoom(state);
  const factor = getZoomScalingFactor(state);
  const computed = rawZoom / factor;
  if (Math.abs(1 - computed) <= 0.01) {
    return 1;
  }
  return computed;
}
